import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSendResetPasswordEmailKey } from '../../utils/keys';
export const useSendResetPasswordEmail = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation(input => client.auth.sendResetPasswordEmail(input), {
        mutationKey: getSendResetPasswordEmailKey(),
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useSendResetPasswordEmail.js.map